import React from 'react';
import { useSelector } from 'react-redux'

import { parseUrl, joinUrl } from "./wheel-urls.js";

const WheelSearchLabels = () => {
  let labels = useSelector(state => state.cars.selectedCarLabels);

  //var parsedUrl = parseUrl();

  //var root = joinUrl({ ...parsedUrl, diameters: null });

  //var diameter = (parsedUrl || {}).diameters;

  //// se il diametro nell'url non risulta tra quelli presenti nella lista 

  //if (!(diameters || []).some(s => s.Key == diameter) && parsedUrl) {
  //  parsedUrl.diameters = null;

  //  // lo eliminiamo dall'url

  //  window.history.pushState("", "", joinUrl(parsedUrl));
  //}

  labels = window.initCarLabels || labels;

  if (labels) {
    return(<div>
      {labels["title"]}
      <div className="ssub-title-height pt-3 pb-3 pb-sm-3" style={{ lineHeight: "16px", fontSize: "14px", whiteSpace: "normal", fontWeight: "500" }}>
        {labels["sub_title"]}
      </div>
    </div>);
  }

  return null;
};

export { WheelSearchLabels };